import { format } from 'date-fns';

export function formatEpochToDate(
  epochTimeInSeconds: number | undefined,
  dateFormat: string = 'yyyy-MM-dd HH:mm:ss',
): string {
  if (!epochTimeInSeconds) {
    return '';
  }

  const epochTimeInMillis = epochTimeInSeconds * 1000;
  const formattedDate = format(new Date(epochTimeInMillis), dateFormat);

  return formattedDate;
}
